import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer} from '@angular/forms';
import { Filter } from '../../../../models/filter.models';


@Component({
  selector: 'date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit {
  public dateFormGroup :any ;
  constructor(
    public controlContainer: ControlContainer
  ) {
  }

  @Input() data: Filter;

  ngOnInit(): void {
    this.dateFormGroup = this.controlContainer.control
  }

}
